import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Splash.css";

function Splash() {

  const navigate = useNavigate();

  useEffect(() => {

    const token = localStorage.getItem("token");

    const timer = setTimeout(() => {

     if (token) {

    navigate("/home");

} else {

    navigate("/welcome");

}

    }, 2500);

    return () => clearTimeout(timer);

  }, [navigate]);

  return (

    <div className="splash-container">

      <div className="splash-content">

        <div className="logo-circle">
          🍽
        </div>

        <h1 className="logo-text">

          HomeFoods

        </h1>

        <p className="tagline">

          Fresh Homemade Food,<br />
          Delivered with Love ❤️

        </p>

        <div className="loader"></div>

      </div>

    </div>

  );

}

export default Splash;